import { assign } from 'xstate';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const clearRequiredIngredientName: CustomizationMachineAction = assign({
  requiredIngredientName: undefined,
});
